<template>
  <div class="mt-12 text-center pt-10 mx-auto" style="max-width: 700px">
          <span class="font-rubik font-weight-medium"
                style="font-size: 2rem"
          >Preguntas frecuentes
          </span>
    <v-expansion-panels
      v-model="selectedFAQ"
      flat
      class="mt-8"
    >
      <v-expansion-panel
        v-for="(item,i) in items"
        :key="i"
      >
        <v-expansion-panel-header class="mt-2"
                                  :style="selectedFAQ+1 !== item ? 'border-bottom: 2px solid #E5E7EB' : ''"
        >
            <span class="font-rubik font-weight-medium" style="font-size: 1.125rem">
              {{ item.title }}
            </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mt-6 text-start">
            <span style="font-weight: 500; font-size: 1.125rem; color: #4B5563"
                  v-html="item.text"
            ></span>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: "PreguntesFrequents",
  data() {
    return {
      selectedFAQ: null,
      items: [
        {
          title: "¿Qué beneficios obtengo al ser Premium?",
          text: `Con el plan Premium de Sele.ai, tendrás acceso a todas nuestras herramientas avanzadas de estudio con IA, incluyendo:
<br>
<br>
• Chat IA ilimitado con tus documentos y asistente académico especializado
<br>
• Generación ilimitada de cuestionarios, resúmenes y tarjetas de estudio
<br>
• Modo anónimo para tus documentos personales
<br>
• Recursos premium y contenido inteligente de la comunidad
<br>
• Posibilidad de descargar todo el material generado
<br>
<br>
Además, estamos constantemente mejorando la plataforma basándonos en el feedback de nuestros usuarios premium.`
        },
        {
          title: "¿Qué opciones de suscripción hay disponibles?",
          text: `Ofrecemos dos opciones de suscripción Premium:
<br>
<br>
1. <b>Premium Pago Único:</b> Por solo €14,99 (precio con descuento del 50%), obtendrás acceso a todas las funciones premium durante 3 meses. Esta es nuestra opción más popular y económica a largo plazo.
<br>
<br>
2. <b>Premium Mensual:</b> Por €8,99 al mes, accederás a todas las funciones premium con la flexibilidad de cancelar cuando quieras.`
        },
        {
          title: "¿Cuáles son las limitaciones del plan gratuito?",
          text: `El plan gratuito te permite probar las funcionalidades básicas de nuestra plataforma, incluyendo:
<br>
<br>
• Chat IA con tus documentos (limitado a 3 preguntas al día)
<br>
• Generación de 1 estudio inteligente al dia (cuestionarios, resúmenes y tarjetas de un documento)
<br>
• Ver apuntes de la comunidad
<br>
<br>
Para acceder a funciones ilimitadas y herramientas avanzadas, te recomendamos actualizar a uno de nuestros planes Premium.`
        },
        {
          title: "¿Qué significa 'ilimitado' en los planes Premium?",
          text: `Cuando decimos 'ilimitado', nos referimos a un uso razonable del servicio. Para el plan de pago único, puedes subir hasta 150 documentos en total durante los 3 meses. Para el plan mensual, puedes subir hasta 50 documentos al mes.
<br>
<br>
Esta política está diseñada para garantizar la mejor experiencia para todos nuestros usuarios mientras mantenemos la calidad del servicio.`
        },
      ]
    }
  },
  computed: {
    nextYear() {
      const d1 = new Date();
      let year = d1.getFullYear();
      let month = d1.getMonth() + 1;
      if (month >= 9) year++;
      return year;
    },
  }
}
</script>

<style scoped>

</style>
